<mat-card appearance="outlined">
    <div class="header">{{'businessTexts.hardwareCertificateManagement' | translate}}</div>
    <mat-card-content>
        <div class="info-container">
            <div class="row border-bottom">
                <div class="col-6"><span class="bold">{{'businessTexts.certificateSerialNumber' | translate}}</span>
                </div>
                <div class="col-6">{{rowData.serialNumber}}</div>
            </div>
            <div class="row border-bottom">
                <div class="col-6"><span class="bold">{{'businessTexts.validFrom' | translate}}</span></div>
                <div class="col-6">{{rowData.validFrom}}</div>
            </div>
            <div class="row border-bottom">
                <div class="col-6"><span class="bold">{{'businessTexts.validTo' | translate}}</span></div>
                <div class="col-6">{{rowData.validTo}}</div>
            </div>
        </div>
        <mat-card appearance="outlined">
            <div class="title-form">
                <span class="bold">{{'businessTexts.managementRequestRetails' | translate}}</span>
            </div>
            <form *ngIf="managementForm && loaded" [formGroup]="managementForm" (ngSubmit)="submitManagementForm()">
                <ng-container *ngIf="!requestCompleted">
                <div class="row">
                    <div class="col-6">
                        <ng-container *ngIf="rowData.status == 'HOLDED'">
                            <mat-form-field>
                                <mat-label>{{ 'businessTexts.actions' | translate }}</mat-label>
                                <mat-select formControlName="revokeAction">
                                    <mat-option *ngFor="let item of translatedActionListExpired" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>

                        <ng-container *ngIf="rowData.status == 'VALID'">
                            <mat-form-field>
                                <mat-label>{{ 'businessTexts.actions' | translate }}</mat-label>
                                <mat-select formControlName="revokeAction">
                                    <mat-option *ngFor="let item of translatedActionListValid" [value]="item.value">
                                        {{ item.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>

                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>{{'businessTexts.applicantName' | translate}}</mat-label>
                            <input matInput type="text" formControlName="requestorName">
                        </mat-form-field>
                        <mat-error *ngIf="managementForm.get('requestorName')?.hasError('required')
          && (managementForm.get('requestorName')?.touched || managementForm.get('requestorName')?.dirty)">
                            {{ 'businessTexts.fieldRequired' | translate }}
                        </mat-error>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>{{'businessTexts.applicantEmail' | translate}}</mat-label>
                            <input matInput type="text" formControlName="requestorContact">
                        </mat-form-field>
                        <mat-error
                            *ngIf="managementForm.get('requestorContact')?.hasError('required')  && (managementForm.get('requestorContact')?.touched || managementForm.get('requestorContact')?.dirty)">
                            {{'businessTexts.fieldRequired' | translate}}
                        </mat-error>
                        <mat-error *ngIf="managementForm.get('requestorContact')?.hasError('emailOrPhone')">
                            {{'businessTexts.enterEemailPhone' | translate}}
                        </mat-error>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>{{'businessTexts.applicantRole' | translate}}</mat-label>
                            <input matInput type="text" formControlName="requestorRole">

                        </mat-form-field>
                        <mat-error *ngIf="managementForm.get('requestorRole')?.hasError('required')
          && (managementForm.get('requestorRole')?.touched || managementForm.get('requestorRole')?.dirty)">
                            {{ 'businessTexts.fieldRequired' | translate }}
                        </mat-error>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>{{'businessTexts.reason' | translate}}</mat-label>
                            <input matInput type="text" formControlName="requestReason">
                        </mat-form-field>
                        <mat-error *ngIf="managementForm.get('requestReason')?.hasError('required')
          && (managementForm.get('requestReason')?.touched || managementForm.get('requestReason')?.dirty)">
                            {{ 'businessTexts.fieldRequired' | translate }}
                        </mat-error>
                    </div>
                </div>
                <div class="button-container">
                    <button mat-raised-button color="primary" (click)="goBack()"
                        [disabled]="disableCancel">{{'businessTexts.cancel'
                        |
                        translate}}</button>
                    <button mat-raised-button
                        [disabled]="!managementForm.valid || !managementForm.dirty || disableCancel" color="primary"
                        type="submit">{{'businessTexts.submit' |
                        translate}}</button>
                </div>
                </ng-container>
                <div class="generate-content">
                    <div [ngClass]="{ 'error-message': showError, 'info-message': !showError }" *ngIf="resMessage">
                        {{ resMessage }}
                    </div>

                    <div class="spinner-container" *ngIf="loading">
                        <mat-spinner class="content-box"></mat-spinner>
                    </div>
                </div>
            </form>
        </mat-card>

        <mat-card appearance="outlined" class="generate-content" *ngIf="attachFile">
            <mat-card-content>
                <!-- <div class="row title-generate">
                    <h4>{{'businessTexts.downloadApplication' | translate }}</h4>
                </div> -->
                <div class="center">
                    <a [href]="applicationUrl" mat-raised-button class="upload-button mat-button"
                        download="application.pdf">
                        {{'businessTexts.downloadApplication' | translate }}
                    </a>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>